import { render, staticRenderFns } from "./ArrowRounded.vue?vue&type=template&id=28bf5adc&"
import script from "./ArrowRounded.vue?vue&type=script&lang=ts&"
export * from "./ArrowRounded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports